import * as React from "react";
import * as moment from "moment";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import WorksheetEditor from "../shared/WorksheetEditor";
import APIClient from "../../APIClient";
import { loadApp } from "../actions";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

require(`../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/\
disclosure_entities.scss`);

interface DisclosureRegenerationProps {
  dispatch?: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class DisclosureRegenerationEditor extends React.Component<DisclosureRegenerationProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      inFlight: false,
    };

    this.triggerRegeneration = this.triggerRegeneration.bind(this);
  }

  triggerRegeneration(esign: boolean) {
    if (esign && !confirm("Are you sure you'd like to start esign?")) {
      return;
    }

    const { app, dispatch } = this.props;

    this.setState({
      errorMessage: null,
      inFlight: true,
    });

    APIClient.post(`/uw/${app.id}/regenerate_latest_disclosure`, {
      // post last_disclosure_snapshot ws id to make absolutely
      // sure we are regenerating from the true latest
      snapshotWsIdVerification: app.disclosures[0].snapshot_worksheet_id,
      esign,
    })
      .then(() => {
        this.setState({ inFlight: false });
        loadApp(dispatch, app.id);
      })
      .catch(errMsg => {
        this.setState({
          errorMessage: errMsg.meta.error_detail,
          inFlight: false,
        });
        loadApp(dispatch, app.id);
      });
  }

  render() {
    const { app, hurdle, onHide } = this.props;

    let body;
    if (app.disclosures.length) {
      const latestDisclosure = app.disclosures[0];
      const latestDisclosureCreatedAt = moment(latestDisclosure.created_at).format(
        "YYYY-MM-DD h:mm:ss a",
      );
      body = (
        <div>
          {this.state.errorMessage !== null && <p>ERROR: {this.state.errorMessage}</p>}
          <p>Latest Disclosure Stage: {latestDisclosure.stage}</p>
          <p>Latest Disclosure E-Sign: {latestDisclosure.esign ? "Yes" : "No"}</p>
          <p>Latest Disclosure Created At: {latestDisclosureCreatedAt}</p>
          <Button
            bsSize="small"
            onClick={() => this.triggerRegeneration(false)}
            disabled={this.state.inFlight}
          >
            Regenerate NON-eSign {latestDisclosure.stage} from this snapshot
          </Button>
          <Button
            bsSize="small"
            onClick={() => this.triggerRegeneration(true)}
            disabled={this.state.inFlight}
          >
            Regenerate ESIGN {latestDisclosure.stage} from this snapshot
          </Button>
          {latestDisclosure.snapshot_worksheet_id && (
            <WorksheetEditor
              appId={app.id}
              loanFileWsId={app.loan_file_worksheet_id}
              openToWsName="snapshot_Snapshot"
              openToWsId={latestDisclosure.snapshot_worksheet_id}
              showChildrenInline
            />
          )}
        </div>
      );
    } else {
      body = (
        <div>
          <p>No disclosures yet</p>
        </div>
      );
    }

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        {body}
        <footer className={styles.footer}>
          <Button bsSize="small" onClick={onHide}>
            <i className="fa fa-thumbs-up" /> OK
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  app: ownProps.app,
  hurdle: ownProps.hurdle,
  onHide: ownProps.onHide,
});

export default connect(mapStateToProps)(DisclosureRegenerationEditor);
